import { MARKETING_ENTERPRISE } from 'self-service-api/constants/UpgradeProducts';
import { PAYMENT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import PaymentsUpgradeModal from 'automation-ui-enrollment/components/workflowType/PaymentsUpgradeModal';
export function getHubSpotDefinedObjectTypeConfig({
  objectTypeId,
  tag,
  upgradeModalKey,
  upgradeProduct
}) {
  let CustomModal = undefined;
  if (objectTypeId === PAYMENT_ID) {
    CustomModal = PaymentsUpgradeModal;
  }
  return {
    objectTypeId,
    badge: tag,
    upgradeModalKey,
    upgradeProduct,
    CustomModal
  };
}
export const getCustomObjectTypeConfig = objectTypeId => {
  return {
    objectTypeId,
    upgradeModalKey: 'workflows-marketing-enterprise',
    upgradeProduct: MARKETING_ENTERPRISE
  };
};
const PROD_APP_OBJECT_CONFIG_ENTRIES = new Map();
export const getAppObjectTypeConfig = objectTypeId => {
  var _PROD_APP_OBJECT_CONF;
  return (_PROD_APP_OBJECT_CONF = PROD_APP_OBJECT_CONFIG_ENTRIES.get(objectTypeId)) !== null && _PROD_APP_OBJECT_CONF !== void 0 ? _PROD_APP_OBJECT_CONF : null;
};